import React from "react";
import { NavLink } from "react-router-dom";

import { useRecoilValue } from "recoil";
import { currentProject } from "lib/store/project";

import "./SidebarItem.scss";

export type SidebarItemProps = {
  cx?: string;
  title: string;
  link?: string;
};

export const SidebarItem: React.FC<SidebarItemProps> = ({
  cx = "",
  title,
  link,
}) => {
  const pid = useRecoilValue(currentProject);
  const root = `/${pid}`;
  return (
    <li className={`SidebarItem ${cx}`}>
      <NavLink end className={"header"} to={root + link || ""}>
        {title}
      </NavLink>
    </li>
  );
};
